$(document).ready(function() {

  // Clock setup
  if ($("#widget-event-clock").length) {
    var clockTimer = setInterval(clockProgress, 1000)
    function clockProgress(){
      var now = new Date();
      var h = now.getHours();
      var m = now.getMinutes();
      var s = now.getSeconds();
      h = widgetClockCleanup(h);
      if (h > 12) { h = h - 12; }
      if (h == 0) { h = 12; }
      m = widgetClockCleanup(m);
      s = widgetClockCleanup(s);
      $("#widget-event-clock").html(h + ":" + m + ":" + s);
    }
    function widgetClockCleanup(i) {
      if (i < 10) {i = "0" + i};  // add zero in front of numbers < 10
      return i;
    }
  }

});

// Managae zeros
function widgetClockCleanup(i,n) {
  var l=(i+"").length;
  for (var j = l; j < n; j++) {
    i = "0" + i;
  }
  return i;
}